import { useState } from 'react';
import ProductNav from '@elem/compPage/delta-3-max-plus-portable-power-station/common/ProductNavUs';

import CardSection from '../../components/CardSection';
import Comparison1 from '../../components/Comparison_back';
import CoverSection1 from '../../components/CoverSection1';
import CoverSection2 from '../../components/CoverSection2';
import CoverSection3 from '../../components/CoverSection3';
import CoverSection4 from '../../components/CoverSection4';
import CutCosts from '../../components/CutCosts';
import Explore from '../../components/Explore';
import PhoneSection from '../../components/PhoneSection';
import TabSection from '../../components/TabSection';
import TC from '../../components/TC';
import Bundles from '../Bundles';
import Banner from './Components/Banner';
import ChargeUp from './Components/ChargeUp';
import Essentials from './Components/Essentials';
import Output from './Components/Output';

import styles from './index.module.scss';

import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import Automotive from './Components/Automotive';
import Automotive2 from './Components/Automotive2/index.';
import Built from './Components/Built';
import CoreAnimation from './Components/CoreAnimation';
import PageNavLeft from './Components/PageNavLeft';
import PriorityOutputs from './Components/PriorityOutputs';
import './nav.scss';
import BottomAction from '@elem/compPage/delta-3-ultra-portable-power-station/pages/product/components/BottomAction';

const StatusA: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('StatusA');
    const { t: tPageNavLeft } = useLang('PageNavLeft');

    const [activeTab, setActiveTab] = useState('Product');

    return (
        <div className={styles.StatusA} id="StatusA">
            <ProductNav activeTab={activeTab} tabCallback={setActiveTab} />

            {activeTab === 'Product' && (
                <>
                    <BottomAction pageType="max" />
                    <Banner pageType="max" />
                    {/* <Redfine /> */}
                    {/* <OnePicture pageType="max" /> */}
                    <CoreAnimation pageType="max" />
                    <div className="range1">{/* <Subscribe pageType="max" /> */}</div>
                    <div className="range2">
                        <CoverSection1 />
                        {/* <MorePower /> */}
                        <Output />
                        <Essentials pageType="max" />
                        <PriorityOutputs pageType="max" />
                    </div>
                    <div className="range3">
                        <CoverSection2 maskEnhance />
                        <ChargeUp pageType="max" />
                    </div>

                    <div className="range4">
                        <CoverSection3 />
                        <Automotive />
                        <Automotive2 />
                        <Built pageType="max" />
                    </div>
                    <div className="range5">
                        <CoverSection4 />
                        <TabSection />
                        <CardSection />
                    </div>
                    <div className="range6">
                        <PhoneSection />
                        <CutCosts />
                        <div style={{ background: '#fff' }}>
                            <Comparison1 />
                            <Explore />
                        </div>
                        <TC />
                    </div>

                    {/* 左侧锚点 */}
                    <PageNavLeft
                        triggerElement={`#StatusA`}
                        enterElement="#OnePicture"
                        triggerElements={[{ selectors: `#StatusA`, theme: 'white' }]}
                        steps={[
                            { text: tPageNavLeft('item1'), href: '#overview-item1' },
                            { text: tPageNavLeft('item2'), href: '#videoSection1' },
                            { text: tPageNavLeft('item3'), href: '#videoSection2' },
                            { text: tPageNavLeft('item4'), href: '#videoSection3' },
                            { text: tPageNavLeft('item5'), href: '#videoSection4' },
                            { text: tPageNavLeft('item6'), href: '#phoneSection' },
                        ]}
                    />
                </>
            )}
            {activeTab === 'Bundles' && (
                <>
                    <Bundles />
                </>
            )}
        </div>
    );
};

export default StatusA;
